import { createIntl, createIntlCache } from 'react-intl';

import { LogService } from '../services/log-service';
import { English } from './locale-context-provider/locale-codes';
import localeData from './locale-data';
import formatters from './formatters';
import { CookieService } from '../services/cookie-service';
import { PreferredLocale } from '../constants/cookies';

export const getLocaleData = (locale) => {
  return localeData[locale]?.() ?? localeData[English]();
};

export const getPreferredLocaleFromUserSetting = (userSettingPreferredLocale) => {
  const cookiePreferredLocale = CookieService.getCookieValue(PreferredLocale);

  return cookiePreferredLocale || userSettingPreferredLocale || English;
};

const getIntl = (preferredLocale) => {
  return new Promise((resolve) => {
    getLocaleData(preferredLocale)
      .then((messageData) => {
        const cache = createIntlCache();
        resolve(
          createIntl(
            {
              locale: preferredLocale,
              messages: messageData,
              defaultRichTextElements: formatters,
            },
            cache,
          ),
        );
      })
      .catch((e) => {
        LogService.logInfo(e);
        resolve();
      });
  });
};

export default getIntl;
